import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BrandCampaignReportUpperCard from "./Components/BrandCampaignReportUpperCard";
import DARReportUpperCard from "./Components/DarReportTable";
// import AnnouncementModal from "./components/AnnouncementModal";

type Props = {};

function BrandCampaignReport({}: Props) {
  return (
    <div className="p-2">
      <PageHeader
        title="Brand Campaign  Report"
        buttons={[
          {
            label: "Excel",
            onClick: () => alert("Download Excel"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Download CSV"),
            color: "#43B9B2",
          },
        ]}
      />
      {/* UPPER DAR REPORT COMPONENT */}
      <BrandCampaignReportUpperCard />
      {/* <DARReportUpperCard /> */}

      {/* Table */}

      <BasicDataTable
        Title=""
        data={employeeReportsData || []}
        columns={employeeReportsColumn}
        search={false}
        // onChangePage={(pageNo: number) => {
        //   handlePagination(pageNo);
        // }}
        // onChangeRowsPerPage={(newPerPage: any, page: any) => {
        //   handleonChangeRowsPerPage(newPerPage, page);
        // }}
        // handleSearch={(val: any) => {
        //   handleSearch(val);
        // }}
        // paginationTotalRows={
        //   leaveRequestDataa?.data?.pagination?.total_records || 0
        // }
        // showheaderContent={true}
      />
    </div>
  );
}

export default BrandCampaignReport;

const employeeReportsColumn = [
  {
    name: "Brand Campaign ID",
    selector: (row: { bcID: string }) => (row.bcID ? row.bcID : "-"),
    sortable: true,
    width: "200px",
  },
  {
    name: "Campaign Name",
    selector: (row: { campaignname: string }) => row.campaignname ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Start Date",
    selector: (row: { startdate: string }) => row.startdate ?? "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "End Date",
    selector: (row: { enddate: string }) => row.enddate || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Locking Date",
    selector: (row: { lockingdate: string }) => row.lockingdate || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "Type",
    selector: (row: { type: string }) => row.type || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Tags",
    selector: (row: { tags: string }) => row.tags || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Dr. Count",
    selector: (row: { drcount: string }) => row.drcount || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Planned",
    selector: (row: { planned: string }) => row.planned || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Done",
    selector: (row: { done: string }) => row.done || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Focus Brand",
    selector: (row: { focusbrand: string }) => row.focusbrand || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Classification ID",
    selector: (row: { classificationid: string }) =>
      row.classificationid || "-",
    sortable: true,
    // width: "150px",
  },
];

const employeeReportsData = [
  {
    bcID: "1845664",
    campaignname: "Vipul Mishra",
    startdate: "17:41:00",
    enddate: "17:41:00",
    lockingdate: "0",
    type: "5 March 2025",
    tags: "1",
    drcount: "1",
    planned: "1",
    done: "1",
    focusbrand: "1",
    classificationid: "1",
  },
  {
    bcID: "1845664",
    campaignname: "Vipul Mishra",
    startdate: "17:41:00",
    enddate: "17:41:00",
    lockingdate: "0",
    type: "5 March 2025",
    tags: "1",
    drcount: "1",
    planned: "1",
    done: "1",
    focusbrand: "1",
    classificationid: "1",
  },
  {
    bcID: "1845664",
    campaignname: "Vipul Mishra",
    startdate: "17:41:00",
    enddate: "17:41:00",
    lockingdate: "0",
    type: "5 March 2025",
    tags: "1",
    drcount: "1",
    planned: "1",
    done: "1",
    focusbrand: "1",
    classificationid: "1",
  },
  {
    bcID: "1845664",
    campaignname: "Vipul Mishra",
    startdate: "17:41:00",
    enddate: "17:41:00",
    lockingdate: "0",
    type: "5 March 2025",
    tags: "1",
    drcount: "1",
    planned: "1",
    done: "1",
    focusbrand: "1",
    classificationid: "1",
  },
  {
    bcID: "1845664",
    campaignname: "Vipul Mishra",
    startdate: "17:41:00",
    enddate: "17:41:00",
    lockingdate: "0",
    type: "5 March 2025",
    tags: "1",
    drcount: "1",
    planned: "1",
    done: "1",
    focusbrand: "1",
    classificationid: "1",
  },
];
